// Original vocabulary. Role tags constrain where a noun may be used.
export default [
  {
    "id": "crayon",
    "role": "countable",
    "singular": "crayon",
    "plural": "crayons",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "pencil",
    "role": "countable",
    "singular": "pencil",
    "plural": "pencils",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "paintbrush",
    "role": "countable",
    "singular": "paintbrush",
    "plural": "paintbrushes",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "bead",
    "role": "countable",
    "singular": "bead",
    "plural": "beads",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "sticker",
    "role": "countable",
    "singular": "sticker",
    "plural": "stickers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "paper-clip",
    "role": "countable",
    "singular": "paper clip",
    "plural": "paper clips",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "button",
    "role": "countable",
    "singular": "button",
    "plural": "buttons",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "eraser",
    "role": "countable",
    "singular": "eraser",
    "plural": "erasers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "marker",
    "role": "countable",
    "singular": "marker",
    "plural": "markers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "stamp",
    "role": "countable",
    "singular": "stamp",
    "plural": "stamps",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "string",
    "role": "measurable",
    "singular": "string",
    "plural": "strings",
    "tags": [
      "length"
    ]
  },
  {
    "id": "fabric",
    "role": "measurable",
    "singular": "fabric",
    "plural": "fabrics",
    "tags": [
      "length"
    ]
  },
  {
    "id": "paper-strip",
    "role": "measurable",
    "singular": "paper strip",
    "plural": "paper strips",
    "tags": [
      "length"
    ]
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "tray",
    "role": "container",
    "singular": "tray",
    "plural": "trays",
    "tags": []
  },
  {
    "id": "basket",
    "role": "container",
    "singular": "basket",
    "plural": "baskets",
    "tags": []
  },
  {
    "id": "case",
    "role": "container",
    "singular": "case",
    "plural": "cases",
    "tags": []
  },
  {
    "id": "artist",
    "role": "person",
    "singular": "artist",
    "plural": "artists",
    "tags": []
  },
  {
    "id": "student",
    "role": "person",
    "singular": "student",
    "plural": "students",
    "tags": []
  },
  {
    "id": "teacher",
    "role": "person",
    "singular": "teacher",
    "plural": "teachers",
    "tags": []
  },
  {
    "id": "designer",
    "role": "person",
    "singular": "designer",
    "plural": "designers",
    "tags": []
  },
  {
    "id": "drawing-session",
    "role": "action",
    "singular": "drawing session",
    "plural": "drawing sessions",
    "tags": []
  },
  {
    "id": "painting-session",
    "role": "action",
    "singular": "painting session",
    "plural": "painting sessions",
    "tags": []
  },
  {
    "id": "art-lesson",
    "role": "action",
    "singular": "art lesson",
    "plural": "art lessons",
    "tags": []
  },
  {
    "id": "exhibition",
    "role": "action",
    "singular": "exhibition",
    "plural": "exhibitions",
    "tags": []
  },
  {
    "id": "easel",
    "role": "structure",
    "singular": "easel",
    "plural": "easels",
    "tags": []
  },
  {
    "id": "display-stand",
    "role": "structure",
    "singular": "display stand",
    "plural": "display stands",
    "tags": []
  },
  {
    "id": "studio",
    "role": "place",
    "singular": "studio",
    "plural": "studios",
    "tags": []
  },
  {
    "id": "gallery",
    "role": "place",
    "singular": "gallery",
    "plural": "galleries",
    "tags": []
  }
];
